import { type FC } from "react";
import { Link } from "react-router-dom";

import { Colors } from "@snapchat/snap-design-system";
import { ArrowRightIcon, Sizes } from "@snapchat/snap-design-system-icons";
import { clsx } from "clsx";

import { MonetizationIcon } from "../../monetization/components/MonetizationIcon";
import { DEFAULT_MONETIZATION_TAB } from "../../monetization/models/monetizationTabs";
import { buildMonetizationTabPath } from "../../monetization/utils/monetizationNavigation";
import { useDefaultOrganizationId } from "../../shared/hooks/useDefaultOrganizationId";
import { linkButtonBlackSmallClassName } from "../../shared/styles/linkButton.styles";

import { banner, content, copy, cta, icon, subtitle, title } from "./HomeMonetizationBanner.module.css";
import { MonetizationBannerCta, MonetizationBannerSubtitle, MonetizationBannerTitle } from "./messages.generated";

export const HomeMonetizationBanner: FC = () => {
    const orgId = useDefaultOrganizationId();
    const href = buildMonetizationTabPath({ orgId, tab: DEFAULT_MONETIZATION_TAB });

    return (
        <div className={banner} data-testid="home-monetization-banner">
            <div className={content}>
                <span className={icon} aria-hidden="true">
                    <MonetizationIcon size={Sizes.Large} />
                </span>
                <div className={copy}>
                    <h2 className={clsx("heading-h500", title)}>
                        <MonetizationBannerTitle />
                    </h2>
                    <p className={clsx("paragraph-p200", subtitle)}>
                        <MonetizationBannerSubtitle />
                    </p>
                </div>
            </div>
            <Link className={clsx(linkButtonBlackSmallClassName, cta)} to={href}>
                <span>
                    <MonetizationBannerCta />
                </span>
                <ArrowRightIcon size={Sizes.Small} fill={Colors.WHITE} aria-hidden="true" />
            </Link>
        </div>
    );
};
